import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* COLUMN 1 */}
        <div className="footer-col">
          <h4>Nimbus BPO</h4>
          <ul>
            <li>About us</li>
            <li>Jobs</li>
            <li>
              Media <span className="badge-new">New</span>
            </li>
            <li>FAQs</li>
            <li>Contact</li>
          </ul>
        </div>

        {/* COLUMN 2 */}
        <div className="footer-col">
          <h4>Industries</h4>
          <ul>
            <li>FinTech</li>
            <li>EdTech</li>
            <li>E-Commerce</li>
            <li>Government</li>
            <li>Automative</li>
            <li>Others</li>
          </ul>
        </div>

        {/* COLUMN 3 */}
        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            <li>Customer support</li>
            <li>Backend Operations</li>
            <li>Technical support</li>
            <li>Telemarketing</li>
            <li>Pre-sales</li>
            <li>Data support</li>
          </ul>
        </div>

        {/* COLUMN 4 */}
        <div className="footer-col">
          <h4>Department</h4>
          <ul>
            <li>Human Resource</li>
            <li>Accounts</li>
            <li>Back Office</li>
            <li>Ops Teams</li>
            <li>Training</li>
            <li>Quality Analysis</li>
          </ul>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">

          <div className="footer-logo">
            <img src="logo.png" alt="Nimbus BPO" />
          </div>

          <div className="footer-links">
            © 2018-24 Nimbus BPO &nbsp; | &nbsp;
            <a href="#">Terms</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Cookies</a>
            <a href="#">Sitemap</a>
          </div>

          <div className="footer-social">
            <i className="fab fa-facebook-f"></i>
            <i className="fab fa-linkedin-in"></i>
            <i className="fab fa-twitter"></i>
            <i className="fab fa-instagram"></i>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
